import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { useAuth } from 'src/user';

export function useLogout() {
  const navigate = useNavigate();
  const { signout } = useAuth();

  const logout = useCallback(() => {
    signout();
    navigate('/');
  }, [signout, navigate]);

  return logout;
}
